import { useState } from "react";

export default function PoolQuote() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pool_type: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="max-w-[800px] mx-auto px-4 py-16 text-center">
        <span className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-green-100 text-green-600">
          <i className="ri-check-line text-2xl"></i>
        </span>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          Thank You!
        </h1>
        <p className="text-gray-600">
          Your pool quote request has been submitted. We will get back to you
          within 24-48 hours.
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-[800px] mx-auto px-4 py-16">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
        Request A Pool Quote
      </h1>
      <p className="text-gray-600 text-sm md:text-base mb-8">
        Fill out the form below and we will get back to you with a custom
        quote for your pool project.
      </p>
      <form
        id="pool-quote-form"
        data-form
        action=""
        method="POST"
        encType="application/x-www-form-urlencoded"
        onSubmit={handleSubmit}
        className="space-y-5"
      >
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Full Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#1e2a5e] focus:ring-1 focus:ring-[#1e2a5e]"
          />
        </div>
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Email Address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#1e2a5e] focus:ring-1 focus:ring-[#1e2a5e]"
          />
        </div>
        <div>
          <label
            htmlFor="phone"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Phone Number
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            required
            value={formData.phone}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#1e2a5e] focus:ring-1 focus:ring-[#1e2a5e]"
          />
        </div>
        <div>
          <label
            htmlFor="pool_type"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Pool Type
          </label>
          <select
            id="pool_type"
            name="pool_type"
            required
            value={formData.pool_type}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#1e2a5e] focus:ring-1 focus:ring-[#1e2a5e] bg-white"
          >
            <option value="">Select Pool Type</option>
            <option value="inground">Inground Pool</option>
            <option value="above-ground">Above Ground Pool</option>
            <option value="not-sure">Not Sure Yet</option>
          </select>
        </div>
        <div>
          <label
            htmlFor="message"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Additional Details
          </label>
          <textarea
            id="message"
            name="message"
            rows={4}
            maxLength={500}
            value={formData.message}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#1e2a5e] focus:ring-1 focus:ring-[#1e2a5e] resize-none"
            placeholder="Tell us about your pool project..."
          />
          <p className="text-xs text-gray-400 mt-1">
            
          </p>
        </div>
        <button
          type="submit"
          className="bg-[#1e2a5e] text-white font-semibold px-8 py-3 hover:bg-[#152045] transition-colors whitespace-nowrap"
        >
          Submit Quote Request
        </button>
      </form>
    </div>
  );
}